(() => {
  if (window.byCabinetMediaVariantSyncV2) return;
  window.byCabinetMediaVariantSyncV2 = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[id^="GalleryThumbnails"] [data-target] button');
    if (!button) return;

    const thumbnail = button.closest('[data-target]');
    const mediaId = thumbnail && String(thumbnail.dataset.target || '').split('-').pop();
    if (!mediaId) return;

    const productSection = button.closest('[id^="MainProduct-"]');
    const variantPicker = productSection && productSection.querySelector('variant-radios, variant-selects');
    const variantJson = variantPicker && variantPicker.querySelector('script[type="application/json"]');
    if (!variantPicker || !variantJson) return;

    let variants;
    try {
      variants = JSON.parse(variantJson.textContent);
    } catch (error) {
      return;
    }

    const matchingVariant = variants.find((variant) => {
      const featuredMediaId = variant.featured_media && variant.featured_media.id;
      const featuredImageId = variant.featured_image && variant.featured_image.id;
      return String(featuredMediaId || featuredImageId || '') === mediaId;
    });
    if (!matchingVariant) return;

    const optionGroups = variantPicker.querySelectorAll('.product-form__input');
    let changedControl = null;

    matchingVariant.options.forEach((value, index) => {
      const optionGroup = optionGroups[index];
      if (!optionGroup) return;

      const radio = Array.from(optionGroup.querySelectorAll('input[type="radio"]'))
        .find((input) => input.value === value);

      if (radio) {
        if (!radio.checked) {
          radio.checked = true;
          changedControl = radio;
        }
        return;
      }

      const select = optionGroup.querySelector('select');
      if (select && select.value !== value) {
        select.value = value;
        changedControl = select;
      }
    });

    if (changedControl) {
      changedControl.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();